export default __webpack_public_path__ + "static/media/6-18_Fs.a9074639.svg";